var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    _vm._b(
      { staticClass: "wl-button", attrs: { disabled: _vm.isTooltip } },
      "el-tooltip",
      _vm.bindTooltip,
      false
    ),
    [
      _vm.isRender
        ? _c(
            "el-button",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShow,
                      expression: "isShow",
                    },
                  ],
                  attrs: {
                    loading: _vm.isLoading,
                    disabled: _vm.isDisabled,
                    onclick: "",
                  },
                  nativeOn: {
                    mouseup: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.mouseup($event)
                    },
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.mousedown($event)
                    },
                  },
                },
                "el-button",
                _vm.button,
                false
              ),
              _vm.$listeners
            ),
            [_vm._t("default", [_vm._v(_vm._s(_vm.button.label))])],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }